import { render, staticRenderFns } from "./multiText.vue?vue&type=template&id=374b881d&scoped=true"
import script from "./multiText.vue?vue&type=script&lang=js"
export * from "./multiText.vue?vue&type=script&lang=js"
import style0 from "./multiText.vue?vue&type=style&index=0&id=374b881d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b881d",
  null
  
)

export default component.exports